export default {"src":"/_next/static/media/badge-svgrepo.05d2b57a.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};